// store/modules/taskpage.js
const getDefaultState = () => {
    return {
      singleView: false,
      hideFooter: false,
      autoCheckin: false,
      spot: null,
      // spot is to be opened like a list tap instead of as single view
      selectViaList: false,
      // spot shown in the task view right now (list detail or single view)
      openSpotId: null,
      // QR scanner or password input of the checkin actions is open
      checkinActionOpen: false,
    };
  };

  const state = getDefaultState();

  const getters = {
    singleView: (state) => state.singleView,
    hideFooter: (state) => state.hideFooter,
    autoCheckin: (state) => state.autoCheckin,
    spot: (state) => state.spot,
    selectViaList: (state) => state.selectViaList,
    openSpotId: (state) => state.openSpotId,
    checkinActionOpen: (state) => state.checkinActionOpen,
  };

  const mutations = {
    SetSingleView(state, singleView) {
      state.singleView = singleView;
    },
    SetHideFooter(state, hideFooter) {
      state.hideFooter = hideFooter;
    },
    SetAutoCheckin(state, autoCheckin) {
      state.autoCheckin = autoCheckin;
    },
    SetSpot(state, spot) {
      state.spot = spot;
    },
    SetSelectViaList(state, selectViaList) {
      state.selectViaList = selectViaList;
    },
    SetOpenSpotId(state, id) {
      state.openSpotId = id;
    },
    SetCheckinActionOpen(state, open) {
      state.checkinActionOpen = open;
    },
    // closing a spot; the task page keeps openSpotId current, the checkin action dialogs are
    // independent of the spot
    resetState(state) {
      Object.assign(state, getDefaultState(), { openSpotId: state.openSpotId, checkinActionOpen: state.checkinActionOpen });
    },
  };

  export default {
    namespaced: true,
    state,
    getters,
    mutations,
  };
